/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
import 'reflect-metadata'
import 'regenerator-runtime/runtime'
import 'pathseg'
import Vue from 'vue'
import Vuex from 'vuex'
import App from '../src/app.vue'
import { pluralize } from '../src/utilities/index'
import router from '../src/router'
import Rollbar from 'rollbar'
import VueComponents from '@springbig/vue-components'
import config from '../src/config/config'
import FileUpload from '../src/directives/file-upload';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import "../src/config/light-icons";
import "../src/config/regular-icons";
import "../src/config/solid-icons";
import { container, tokens } from "@springbig/sb-components";
import Particles from "particles.vue";
import VueYoutube from 'vue-youtube'

import "@springbig/vue-components/dist/vue-components.css"
import "@springbig/sb-components/dist/springbig-components.esm.css"

if(config.rollbar.enabled){
  const rollbar = new Rollbar({
    accessToken: config.rollbar.accessToken,
    captureUncaught: true,
    captureUnhandledRejections: true,
    environment: config.environment,
    reportLevel: 'error'
  });

  container.register(tokens.rollbar, { useValue: rollbar });

  Vue.prototype.$rollbar = rollbar

  Vue.config.errorHandler = (err, vm, info) => {
    vm.$rollbar.error(err);
    throw err; // rethrow
  };
}

container.register(tokens.store, { useValue: store });

Vue.use(Vuex);
Vue.filter('pluralize', pluralize)
Vue.use(VueComponents)
Vue.use(FileUpload)
Vue.use(Particles);
Vue.use(VueYoutube)
Vue.component('fai', FontAwesomeIcon)

import { store } from '../src/store'
new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#spa-view')
